import React from "react";
// import "./styles.css";
import "../../assets/css/cseditor.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useEffect, useState } from "react";
// import { HtmlBody } from "../MainContent/HtmlBody";
// import { HTML } from "../MainContent/html";
// import { MathComponent } from "mathjax-react";
import ClassicEditor from "ckeditor5-build-classic-mathtype";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Editor from "@juniyadi/ckeditor5-custom-build";
import parse from "html-react-parser";
import { saveHTML, getHTML, toHTML } from "../../api";
// import Post from "../MainContent/Post";
import severUrl from "../../api";
import axios from "axios";

// import ReactDOMServer from "react-dom/server";
// const htmlString = ReactDOMServer.renderToString(
//   <Post
//     data={{
//       slug: "matrix-completion-using-blended-pairwise-condition-conditional-gradient-over-spectrahedron",
//     }}
//   />
// );

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}
class MyUploadAdapter {
  constructor(props) {
    // CKEditor 5's FileLoader instance.
    this.loader = props;
    // URL where to send files.
    this.url = `${severUrl}blog/upload/image/`;
  }
  // Starts the upload process.
  upload() {
    return new Promise((resolve, reject) => {
      this._initRequest();
      this._initListeners(resolve, reject);
      this._sendRequest();
    });
  }
  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }
  // Example implementation using XMLHttpRequest.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());
    xhr.open("POST", this.url, true);
    xhr.responseType = "json";
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.setRequestHeader("Content-Type", "multipart/form-data");

    // xhr.setRequestHeader("Authorization", getToken());
  }
  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`;
    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }
      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      resolve({
        default: response.s3Url,
      });
    });
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }
  // Prepares the data and sends the request.
  _sendRequest() {
    const data = new FormData();
    this.loader.file.then((result) => {
      data.append("file", result);
      // this.xhr.send(data);
      axios
        .post(this.url, data, {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
          },
        })
        .then((response) => response.data)
        .then((d) => {
          console.log(d);
        });
    });
  }
}

export const MyEditor = () => {
  const [text, setText] = useState(null);
  const [ckText, setCKText] = useState("start");

  const [abstract, setAbstract] = useState("");
  const [image, setImage] = useState(null);
  const [slug, setSlug] = useState(
    "matrix-completion-using-blended-pairwise-condition-conditional-gradient-over-spectrahedron"
  );
  const [html, setHTML] = useState("");
  const [ROL, setROL] = useState("true");
  const [num, setNum] = useState(true);

  useEffect(() => {
    toHTML(slug).then((resp) => {
      if (resp) {
        console.log(resp.data.content);
        setText(resp.data.content);
        setHTML(resp.data.content);
      }
    });

  }, []);

  const onTextChange = (e) => {
    setText(e.target.value);
  };

  const onTransfer = (e) => {
    setNum(!num);
    if (num) {
      setCKText(text);
    } else {
      setText(ckText);
    }
  };

  const onSlugChange = (e) => {
    setSlug(e.target.value);
  };
  const onAbstractChange = (e) => {
    setAbstract(e.target.value);
  };
  const saveChange = (e) => {
    saveHTML(slug, abstract, text).then((resp) => {
      if (resp) {
        setSlug(resp.data.slug);
      }
    });
  };
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ maxWidth: "50%" }}>
        {/* <h2>Using CKEditor&nbsp;5 buil d in React</h2> */}
        {/* <div>{text}</div> */}
        {/* <HtmlBody content={text} />
        <MathComponent tex={text} />}
        {parse(html)}
        
        {/* {parse(htmlString)} */}
        {/* <HTML content={text} />  */}
        {/* <HtmlBody content={text} /> */}
        {parse(html)}
      </div>
      <div>
        <textarea
          name="1"
          value={abstract}
          placeholder="Abstract"
          onChange={(e) => onAbstractChange(e)}
        />
        <textarea
          name="2"
          value={slug}
          placeholder="Slug"
          onChange={(e) => onSlugChange(e)}
        />
        <textarea name="3" value={text} onChange={onTextChange} />
        <button onClick={onTransfer}>Transfer Editor</button>
        <CKEditor
          config={{
            extraPlugins: [MyCustomUploadAdapterPlugin],
            // plugins: [AutoImage],
            // plugins: [ImageInsertViaUrl],
            // initialData: text,
            fontFamily: {
              options: [
                "default",
                "Ubuntu, Arial, sans-serif",
                "Ubuntu Mono, Courier New, Courier, monospace",
              ],
            },
            toolbar: {
              shouldNotGroupWhenFull: true,
              items: [
                "heading",
                "|",
                // 'fontfamily', 'fontsize', '|',
                // 'alignment', '|',
                // 'fontColor', 'fontBackgroundColor', '|',
                "bold",
                "italic",
                "strikethrough",
                "underline",
                "subscript",
                "superscript",
                "|",
                "link",
                "|",
                "outdent",
                "indent",
                "|",
                "bulletedList",
                "numberedList",
                "todoList",
                "|",
                "code",
                "codeBlock",
                "|",
                "insertTable",
                "|",
                "blockQuote",
                "|",
                "imageUpload",
                "mediaEmbed",
                "undo",
                "redo",
                "|",
                "MathType",
                "ChemType",
              ],
            },
          }}
          editor={ClassicEditor}
          data={ckText}
          onReady={(editor) => {
            // You can store the "editor" and use when it is needed.
            console.log("Editor is ready to use!", editor);
            // console.log(text);
            // editor.setData(text);
          }}
          onChange={(event, editor) => {
            // console.log(event);
            const data = editor.getData();
            setCKText(data);
            // console.log({ event, editor, data });
          }}
          onBlur={(event, editor) => {
            // console.log("Blur.", editor);
          }}
          onFocus={(event, editor) => {
            // console.log("Focus.", editor);
            // console.log(text)
          }}
        />
        <button
          onClick={() => {
            navigator.clipboard
              .readText()
              .then((text) => {
                navigator.clipboard.writeText(
                  `
                  <pre><code>` +
                    text +
                    `</code></pre>
                  `
                );
              })
              .catch((err) => {
                console.error("Failed to read clipboard contents: ", err);
              });


            // navigator.clipboard
            // .readText()
            // .then(
            //   (clipText) =>
            //     (document.querySelector(".cliptext").innerText = clipText)
            // );
          }}
        >
          click to copy code area
        </button>
        <button
          onClick={() => {
            navigator.clipboard
              .readText()
              .then((text) => {
                navigator.clipboard.writeText(
                  `
                  <figure><img src="` +
                    text +
                    `"></img></figure>
                  `
                );
              })

              .catch((err) => {
                console.error("Failed to read clipboard contents: ", err);
              });
          }}
        >
          click to copy figure
        </button>
        <button onClick={saveChange}>Save</button>
      </div>
    </div>
  );
};
